module.exports = __webpack_public_path__ + "img/placeholder-16-9.bb314177.png";